import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import { memo } from 'react';

var _templateObject;
var buttonShadowColors = {
  accent1: 'accent1Darkest',
  primary: 'primaryDarkest',
  secondary: 'secondaryDarkest'
};
var derriveHeightAndWidth = function derriveHeightAndWidth(_ref) {
  var _ref$toggleSize = _ref.toggleSize,
    toggleSize = _ref$toggleSize === void 0 ? 'large' : _ref$toggleSize;
  if (toggleSize === 'large') {
    return '32px';
  }
  if (toggleSize === 'medium') {
    return '24px';
  }
  return '18px';
};
var derriveBackgroundColor = function derriveBackgroundColor(_ref2) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'secondary' : _ref2$color,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? themes["default"] : _ref2$theme;
  return theme.palette[color];
};
var derriveBoxShadow = function derriveBoxShadow(_ref3) {
  var _ref3$color = _ref3.color,
    color = _ref3$color === void 0 ? 'secondary' : _ref3$color,
    _ref3$on = _ref3.on,
    on = _ref3$on === void 0 ? false : _ref3$on,
    _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? themes["default"] : _ref3$theme;
  return "".concat(on ? '-1px' : '1px', " 0px 2px ").concat(on ? theme.palette[buttonShadowColors[color]] : 'rgba(0, 0, 0, .3)');
};
var derriveBorder = function derriveBorder(_ref4) {
  var _ref4$on = _ref4.on,
    on = _ref4$on === void 0 ? false : _ref4$on;
  return !on ? '1px solid #EBEBEB' : null;
};
var ToggleSwitchButton = styled('span')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  transition: all 0.1s ease-in;\n  box-shadow: ", ";\n  border: ", ";\n\n  &:after {\n    content: '';\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    height: 6px;\n    width: 6px;\n    background-color: white;\n  }\n"])), derriveHeightAndWidth, derriveHeightAndWidth, derriveBackgroundColor, derriveBoxShadow, derriveBorder);
var ToggleSwitchButton$1 = /*#__PURE__*/memo(ToggleSwitchButton);

export default ToggleSwitchButton$1;
